module.controller('reportClientListCtrl', [ '$scope', '$rootScope', '$state', 'reportService', 'alertService', 'permissionStatesService', 'ASEBIOL_CONSTANTS', 'securityService', reportClientListCtrlFn ]);
function reportClientListCtrlFn($scope, $rootScope, $state, ReportService, alertService, stateService, ASEBIOL_CONSTANTS, securityService) {
	var vm = $scope;

	vm.idPlan = $state.params.idPlan;
	vm.idClient = $state.params.idClient;

	vm.loading = false;
	vm.reports = [];
	vm.filter = {};

	vm.pagination = {
		current : 1,
		total : 0
	};

	$scope.DATE_FORMAT = ASEBIOL_CONSTANTS.DATE_FORMAT;

	vm.loadReportInfoSuccess = function(response) {
		vm.loading = false;
		var responseData = response.getData();

		vm.reports = responseData.results;

		for (i = 0; i < vm.reports.length; i++) {
			responseData.results[i].reportDate = moment(responseData.results[i].reportDate, ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT).toDate();

		}

		var result = response.getData();
		vm.pagination.total = result.totalRegisters;
	};
	
	vm.loadReportInfoError = function(response) {
		vm.loading = false;
	};
	
	/**
	 * Carga infromacion del plan de muestreo
	 */
	vm.loadReportInfo = function(idPlanSampling, idClient) {
		vm.loading = true;
		vm.onPageChange(1);

		if (securityService.hasRole(ROLE_TYPE.CLIENT.code)) {
			ReportService.searchByPlanSampling(idPlanSampling).then(function(response) {
				vm.loadReportInfoSuccess(response);
			}, function(response) {
				vm.loadReportInfoError(response);
			});
		}
		else{
			ReportService.searchByClient(idClient, idPlanSampling).then(function(response) {
				vm.loadReportInfoSuccess(response);
			}, function(response) {
				vm.loadReportInfoError(response);
			});
		}
	};

	vm.siteFilter = function(report) {
		var sites = [];

		for (r = 0; r < report.reportsClientSample.length; r++) {

			var siteName = report.reportsClientSample[r].site.name;

			if (sites.indexOf(siteName) == -1) {

				sites.push(siteName);

			}
		}
		return sites;

	};

	vm.onPageChange = function(page) {
		vm.loading = true;

		page = page == undefined ? 1 : page;
		vm.pagination.current = page;

		var filter = {};
		filter.offset = (page - 1) * $rootScope.pageSize;
		filter.limit = $rootScope.pageSize;

		if (vm.filter.name) {
			filter.name = vm.filter.name;
		}
	}

	vm.opcionesQTip = {
		position : {
			my : 'top right', // Position my top left...
			at : 'bottom right',
			target : 'mouse',
			adjust : {
				x : 5,
				y : 5
			},
		},
		show : {
			delay : 500
		}
	};

	vm.cancelReport = function(report) {
		alertService.showSwtWarningQuestion("Cancelar informe", function() {
			ReportService.cancelReport(report.id).then(function(response) {
				report.reportState = REPORT_STATE.CANCEL.enumName;
				alertService.showSuccess("Informe cancelado exitosamente");
			}, function() {
			})
		});
	}

	/**
	 * Carga la informacion a paenas inicia
	 */

	vm.loadReportInfo(vm.idPlan, vm.idClient);

}
